import { render, staticRenderFns } from "./footer-info.vue?vue&type=template&id=33644d9e&scoped=true"
import script from "./footer-info.vue?vue&type=script&lang=js"
export * from "./footer-info.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33644d9e",
  null
  
)

export default component.exports